// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"Image_imageWrapper__7vHm7","image":"Image_image__jXYoc"};